
export default function StorySection() {
  return (
    <section className="py-20 bg-gradient-to-br from-blue-50 to-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-block bg-blue-100 text-blue-800 px-4 py-2 rounded-full text-sm font-semibold mb-4">
            ストーリー｜ベルギーのベンジャミンさん(仮名)
          </div>
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            「残業が日常」だった段取りが、<br />
            家族の時間を取り戻した日。
          </h2>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-center mb-16">
          <div className="space-y-8">
            <div className="bg-white rounded-xl p-8 shadow-lg border border-gray-200">
              <div className="flex items-center mb-6">
                <div className="w-12 h-12 bg-red-100 rounded-lg flex items-center justify-center mr-4">
                  <i className="ri-map-pin-line text-2xl text-red-600"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900">背景</h3>
                  <p className="text-gray-600">ベルギーの航空機部品工場</p>
                </div>
              </div>
              <p className="text-gray-700 leading-relaxed">
                人手不足で1人当たり生産性MAXが常態。段取り担当のベンジャミンは、ポーキュパインカッター15本/日のチップ交換に追われていた。
              </p>
            </div>

            <div className="bg-red-50 border border-red-200 rounded-xl p-8">
              <div className="flex items-center mb-6">
                <div className="w-12 h-12 bg-red-100 rounded-lg flex items-center justify-center mr-4">
                  <i className="ri-alarm-warning-line text-2xl text-red-600"></i>
                </div>
                <h3 className="text-xl font-bold text-red-800">問題</h3>
              </div>
              <div className="space-y-4">
                <p className="text-red-700 font-medium">
                  摩耗状況の確認→未使用コーナー探し→締付け…
                </p>
                <div className="bg-red-100 rounded-lg p-4">
                  <p className="text-red-800 font-bold text-lg text-center">
                    1本20–30分 × 15本＝約7時間/日が"交換"で消える。
                  </p>
                </div>
                <p className="text-red-700">
                  他の段取りもあり、毎日残業。1歳の子どもと過ごす時間がない。
                </p>
              </div>
            </div>
          </div>

          <div className="space-y-8">
            <div className="bg-yellow-50 border border-yellow-200 rounded-xl p-8">
              <div className="flex items-center mb-6">
                <div className="w-12 h-12 bg-yellow-100 rounded-lg flex items-center justify-center mr-4">
                  <i className="ri-lightbulb-line text-2xl text-yellow-600"></i>
                </div>
                <h3 className="text-xl font-bold text-yellow-800">転機</h3>
              </div>
              <p className="text-yellow-700 leading-relaxed mb-4">
                上司であるニコラス社長（仮名）がZOLLER / micBox導入を決断。
              </p>
              <p className="text-yellow-700 font-medium">
                → 自動反転・自動トルク・履歴ログで、確認から締付けまで自動化。
              </p>
            </div>

            <div className="bg-green-50 border border-green-200 rounded-xl p-8">
              <div className="flex items-center mb-6">
                <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center mr-4">
                  <i className="ri-check-double-line text-2xl text-green-600"></i>
                </div>
                <h3 className="text-xl font-bold text-green-800">結果</h3>
              </div>
              <div className="space-y-3">
                <div className="flex items-center space-x-3">
                  <div className="w-3 h-3 bg-green-500 rounded-full flex-shrink-0"></div>
                  <span className="text-green-700">チップ交換：20–30分 → 仕掛けのみ（1時間／日程度）（大幅短縮）</span>
                </div>
                <div className="flex items-center space-x-3">
                  <div className="w-3 h-3 bg-green-500 rounded-full flex-shrink-0"></div>
                  <span className="text-green-700">交換起因の止まり・ムラが激減、ライン安定。</span>
                </div>
                <div className="flex items-center space-x-3">
                  <div className="w-3 h-3 bg-green-500 rounded-full flex-shrink-0"></div>
                  <span className="text-green-700">ベンジャミンの残業ほぼゼロ。家族時間が復活。</span>
                </div>
                <div className="flex items-center space-x-3">
                  <div className="w-3 h-3 bg-green-500 rounded-full flex-shrink-0"></div>
                  <span className="text-green-700">余力で全体最適の提案を連発 → 現場全体の効率化に波及。</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="text-center mb-12">
          <div className="bg-gradient-to-r from-blue-600 to-purple-600 text-white rounded-2xl p-8 max-w-4xl mx-auto">
            <h3 className="text-2xl font-bold mb-4">一言まとめ</h3>
            <p className="text-xl leading-relaxed">
              段取りを"人の根性"から"仕組み"へ。<br />
              micBoxは、利益だけでなく、人生の時間まで取り戻した。
            </p>
          </div>
        </div>

        <div className="mt-16 grid md:grid-cols-3 gap-8">
          <div className="text-center">
            <div className="w-20 h-20 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-time-line text-4xl text-red-600"></i>
            </div>
            <h4 className="text-lg font-bold text-gray-900 mb-2">導入前</h4>
            <p className="text-gray-600">7時間/日の交換作業<br />毎日残業、家族時間なし</p>
          </div>

          <div className="text-center">
            <div className="w-20 h-20 bg-yellow-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-arrow-right-line text-4xl text-yellow-600"></i>
            </div>
            <h4 className="text-lg font-bold text-gray-900 mb-2">micBox導入</h4>
            <p className="text-gray-600">自動反転・自動トルク<br />履歴ログで完全自動化</p>
          </div>

          <div className="text-center">
            <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-heart-line text-4xl text-green-600"></i>
            </div>
            <h4 className="text-lg font-bold text-gray-900 mb-2">導入後</h4>
            <p className="text-gray-600">1時間程度の仕掛けのみ<br />家族時間復活、現場改善</p>
          </div>
        </div>
      </div>
    </section>
  );
}
